import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { BaseDashboardInfoComponent } from './base-dashboard-info.component';
import { FormattingService } from '../../../../shared/services/formatting.service';

@Component({
  selector: 'activation-kpi-info',
  template: `
    <span title="The total forecast in USD of all webshops in this list">{{forecast}}</span>
  `
})
export class ActivationKpiInfoComponent extends BaseDashboardInfoComponent implements OnChanges {
  public forecast:string;

  constructor(
    private formattingService:FormattingService
  ) {
    super();
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.loading) {
      this.getForecastFromReportData();
    }
  }

  private getForecastFromReportData():void {
    const num:number = this.section?.report?.data?.aggregates?.sum?.Deforus;
    this.forecast = this.formattingService.formatAmount(num, 'USD');
  }
}